import React from "react";
import Synonyms from "./Synonyms";

export default function Meanings(props) {
  return (
    <div className="meanings">
      <h2 className="title-font part-of-speech">
        {props.meanings.partOfSpeech}
      </h2>
      <div className="contents-result">
        {props.meanings.definitions.map(function (definitions, index) {
          return (
            <div key={index}>
              {getDefinition(definitions.definition)}
              {getExample(definitions.example)}
              <br />
            </div>
          );
        })}
        <br />

        <Synonyms synonyms={props.meanings.synonyms} />
      </div>
    </div>
  );

  function getDefinition(definition) {
    if (definition) {
      return (
        <div className="definition">
          <strong className="title-font">Definition: </strong>
          {definition}
        </div>
      );
    } else {
      return null;
    }
  }

  function getExample(example) {
    if (example) {
      return (
        <div className="example">
          <strong className="subtitle-font">
            <em>Example: </em>
          </strong>
          <em className="examples">{example}</em>
        </div>
      );
    } else {
      return null;
    }
  }
}
